import * as React from 'react';
import { Rule, RulesMessages } from '../utils/validator';
import TextInput from './TextInput';
import { HatType } from './Hat';

interface MaskedInputProps {
  placeHolder?: string;
  name: string;
  inputMode?: 'decimal' | 'numeric' | 'tel';
  value?: string;
  id: string;
  label: string;
  required?: boolean;
  focus?: boolean;
  hasError?: boolean;
  errors?: any;
  maxLength?: number;
  minLength?: number;
  theme?: 'night' | 'day';
  validationRules?: Rule[];
  rulesMessages?: RulesMessages;
  allowRegex?: any;
  onChange?: Function;
  onComplete?: Function;
  onError?: Function;
  onBlur?: Function;
  onEsc?: Function;
  onEnter?: Function;
  onLeft?: Function;
  onRight?: Function;
  onUp?: Function;
  onDown?: Function;
  onSpace?: Function;
  hat?: HatType[];
  readOnly?: boolean;
  disabled?: boolean;
  toolTip?: React.ReactNode;
  autocomplete?: string;
}

interface MaskedInputState {
  visibility: boolean;
}

export default function MaskedInput(props: MaskedInputProps) {
  const [state, setState] = React.useState<MaskedInputState>({
    visibility: false
  });
  let allowRegexOnInputMode: null | RegExp = null;
  if (props.inputMode) {
    switch (props.inputMode) {
      case 'numeric':
      case 'tel': {
        allowRegexOnInputMode = /^[0-9]+$/;
        break;
      }
      case 'decimal': {
        allowRegexOnInputMode = /^\$?[0-9]*\.?[0-9]?[0-9]?$/;
        break;
      }
      default: {
        allowRegexOnInputMode = null;
      }
    }
  }
  const { allowRegex = allowRegexOnInputMode } = props;

  const className = state.visibility ? 'eye-close icon' : 'eye-open icon';

  return (
    <TextInput
      placeHolder={props.placeHolder}
      inputMode={props.inputMode}
      name={props.name}
      value={props.value}
      id={props.id}
      label={props.label}
      required={props.required}
      focus={props.focus}
      hasError={props.hasError}
      errors={props.errors}
      maxLength={props.maxLength}
      minLength={props.minLength}
      theme={props.theme}
      validationRules={props.validationRules}
      allowRegex={allowRegex}
      onComplete={props.onComplete}
      onChange={props.onChange}
      onError={props.onError}
      onBlur={props.onBlur}
      onEsc={(inputValue: string) => {
        if (props.onEsc !== undefined) {
          props.onEsc(inputValue);
        }
      }}
      onEnter={(inputValue: string) => {
        if (props.onEnter !== undefined) {
          props.onEnter(inputValue);
        }
      }}
      onUp={(inputValue: string) => {
        if (props.onUp !== undefined) {
          props.onUp(inputValue);
        }
      }}
      onDown={(inputValue: string) => {
        if (props.onDown !== undefined) {
          props.onDown(inputValue);
        }
      }}
      onLeft={(inputValue: string) => {
        if (props.onLeft !== undefined) {
          props.onLeft(inputValue);
        }
      }}
      onRight={(inputValue: string) => {
        if (props.onRight !== undefined) {
          props.onRight(inputValue);
        }
      }}
      onSpace={(inputValue: string) => {
        if (props.onSpace !== undefined) {
          props.onSpace(inputValue);
        }
      }}
      onKeyDown={(e: any) => {
        if (e.target.getAttribute('first-time') === 'true') {
          e.target.select();
          e.target.setAttribute('first-time', 'false');
        }
      }}
      onFocus={(e: any) => {
        e.target.setAttribute('first-time', 'true');
      }}
      type={state.visibility ? 'text' : 'password'}
      hat={props.hat}
      readOnly={props.readOnly}
      disabled={props.disabled}
      toolTip={props.toolTip}
      autocomplete={props.autocomplete}
      rulesMessages={props.rulesMessages}
    >
      <div className="masked-input-icon">
        <div
          role="button"
          aria-label={
            state.visibility ? `Hide ${props.label}` : `Show ${props.label}`
          }
          aria-disabled={props.disabled}
          className={className}
          onMouseDown={(e: any) => {
            e.preventDefault();
            setState({ ...state, visibility: !state.visibility });
          }}
          onKeyDown={(e: any) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
              e.preventDefault();
              setState({ ...state, visibility: !state.visibility });
            }
          }}
          tabIndex={props.disabled ? -1 : 0}
        ></div>
      </div>
    </TextInput>
  );
}
